import React from "react";
import MainLogo from "../../assets/logo/access_account.svg";

export const Logo = (props) => {
    return <img src={MainLogo} {...props} alt="Steel Mains" />;
};
